import React, { memo } from 'react'
import clsx from 'clsx'
import { Container } from '@material-ui/core'
import EditableHTML from '@v4/components/common/EditableHTML'
import PropTypes from 'prop-types'
import PageMetaData from '@v4/utils/data/PageMetaData'
import EditableContainer from '@v4/components/common/EditableContainer'
import AdditionalText from '@v4/components/sections/FAQ/components/AdditionalText'
import Item from './components/Item'
import { useFAQ2 } from './FAQ2.hooks'

const FAQ2 = props => {
	const [
		{
			classes,
			items,
			contentWidth,
			mobileAlignment,
			mobileButtonWidth,
			alignment,

			mataText,
			textMetaKey,

			metaButtonText,
			buttonTextMetaKey,
			metaButtonAction,
			buttonButtonLink,

			title,
			titleKey,
			titleConfig,
			titleEditable,
		},
		{ handleTitleClick, handleTitleChange },
	] = useFAQ2(props)

	return (
		<div className="faq-2">
			<Container className={clsx(classes.container, 'faq-2-container')} maxWidth={contentWidth}>
				<EditableContainer
					visible={!!title}
					fieldConfig={titleConfig}
					onAdd={handleTitleChange}
					editable={titleEditable}
				>
					<EditableHTML
						key={titleKey}
						className={clsx(classes.title, 'FAQ-2-text-block-title')}
						gutterBottom
						html={title}
						onClick={handleTitleClick}
						editable={titleEditable}
						onChange={handleTitleChange}
					/>
				</EditableContainer>

				{!_.isEmpty(items) && (
					<div className={clsx(classes.itemsContainer, 'faq-2-items-container')}>
						{_.map(items, (key, index) => (
							<Item key={key} itemKey={key} group="items" index={index} />
						))}
					</div>
				)}

				<AdditionalText
					className={classes.row}
					alignment={alignment}
					mobileAlignment={mobileAlignment}
					mobileButtonWidth={mobileButtonWidth}
					mataText={mataText}
					textMetaKey={textMetaKey}
					metaButtonText={metaButtonText}
					buttonTextMetaKey={buttonTextMetaKey}
					metaButtonAction={metaButtonAction}
					buttonButtonLink={buttonButtonLink}
				/>
			</Container>
		</div>
	)
}

FAQ2.propTypes = {
	metaData: PropTypes.shape({
		title: PropTypes.instanceOf(PageMetaData),
		additionalText: PropTypes.instanceOf(PageMetaData),
		buttonText: PropTypes.instanceOf(PageMetaData),
		buttonAction: PropTypes.instanceOf(PageMetaData),
		buttonLink: PropTypes.instanceOf(PageMetaData),
		items: PropTypes.instanceOf(PageMetaData),
		alignment: PropTypes.instanceOf(PageMetaData),
		contentWidth: PropTypes.instanceOf(PageMetaData),
		backgroundDefault: PropTypes.instanceOf(PageMetaData),
		primary: PropTypes.instanceOf(PageMetaData),
		marginTop: PropTypes.instanceOf(PageMetaData),
		marginBottom: PropTypes.instanceOf(PageMetaData),
		mobileAlignment: PropTypes.instanceOf(PageMetaData),
		mobileButtonWidth: PropTypes.instanceOf(PageMetaData),
		overrideXsMargins: PropTypes.instanceOf(PageMetaData),
		xsMarginTop: PropTypes.instanceOf(PageMetaData),
		xsMarginBottom: PropTypes.instanceOf(PageMetaData),
	}).isRequired,
}

export default memo(FAQ2)
